import React from 'react';
import { Table } from 'semantic-ui-react';
import { renderDataAsPlainText } from '../../api/renderPrismicData';

const TableItems = ({ items }) => {
  return (
    <Table.Body>
      {items.map(({ key, value }) => {
        return (
          <Table.Row>
            <Table.Cell>{renderDataAsPlainText(key)}</Table.Cell>
            <Table.Cell>{renderDataAsPlainText(value)}</Table.Cell>
          </Table.Row>
        );
      })}
    </Table.Body>
  );
};

export default TableItems;



// WEBPACK FOOTER //
// ./src/components/Prices/TableItems.js